"use client";

import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SecondaryCta() {
  const {
    ref: containerRef,
    isVisible: containerVisible
  } = useRevealOnScroll({
    threshold: 0.3,
    once: true
  });
  const {
    ref: buttonRef,
    isVisible: buttonVisible
  } = useRevealOnScroll({
    threshold: 0.3,
    once: true
  });
  return <section className="relative py-20 overflow-hidden">
      {}
      <div className="absolute inset-0 bg-gradient-to-br from-primary-dark via-accent-dark to-primary-dark" />
      
      {}
      <div className="container relative mx-auto px-4">
        <div className="flex flex-col items-center justify-center gap-8 text-center max-w-2xl mx-auto">
          {}
          <div ref={containerRef} className={`transition-all duration-[var(--duration-medium)] ease-out ${containerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
            <h2 className="text-3xl md:text-4xl font-display font-bold text-foreground-dark mb-4">
              Prêt à capturer vos moments précieux ?
            </h2>
            <p className="text-lg text-secondary leading-relaxed">
              Confiez vos projets à JokerStudio et découvrez une création visuelle qui dépasse vos attentes.
            </p>
          </div>

          {}
          <div ref={buttonRef} className={`w-full sm:w-auto transition-all duration-[var(--duration-medium)] ease-out ${buttonVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
          transitionDelay: buttonVisible ? "100ms" : "0ms"
        }}>
            <Button size="lg" className="w-full sm:w-auto px-12 py-6 text-base font-semibold transition-all duration-[120ms] ease-in-out hover:scale-[1.03] hover:brightness-95 focus-visible:scale-[1.03]">
              Contactez-nous maintenant
            </Button>
          </div>
        </div>
      </div>
    </section>;
}